import { QuestionCircleOutlined } from '@ant-design/icons'
import type { ReactNode } from 'react'
import Popover from '../../Popover'

type HelpPopoverProps = {
  title: string | undefined
  content: ReactNode | undefined
  className?: string
}

const HelpPopover = (props: HelpPopoverProps) => {
  const { title, content, className } = props

  return (
    <Popover title={title} content={content}>
      <QuestionCircleOutlined className={className} />
    </Popover>
  )
}

export default HelpPopover
